function getBannerSwiperParams() {
    let windowWidth = window.innerWidth;

    // Params for mobile
    if (windowWidth <= 991) {
        return {
            direction: 'horizontal',
            loop: true,
            spaceBetween: 20,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            }
        }
        // Params for desktop
    } else if (windowWidth > 991) {
        return {
            direction: 'horizontal',
            loop: true,
            effect: 'fade',
            crossFade: true,
            allowTouchMove: false,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        }
    }
}

let bannerSwiper = false;
bannerSwiper = new Swiper('.section--banner .swiper', getBannerSwiperParams());

window.addEventListener('resize', function () {
    if (bannerSwiper) {
        bannerSwiper.destroy();
    }

    bannerSwiper = new Swiper('.section--banner .swiper', getBannerSwiperParams());
});
